import { useEffect } from 'react';
import { useUIStore } from '@/stores/uiStore';

const MOBILE_BREAKPOINT = '(max-width: 768px)';

export function useMediaQuery() {
  const setMobile = useUIStore((s) => s.setMobile);
  const closeSidebar = useUIStore((s) => s.closeSidebar);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_BREAKPOINT);

    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
      const mobile = e.matches;
      setMobile(mobile);
      if (mobile) {
        closeSidebar();
      }
    };

    // Set initial value
    handleChange(mql);

    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, [setMobile, closeSidebar]);
}
